export class DeskController {
    static $inject = ['$stateParams', '$scope', '$location', '$sce', 'LoadingService', 'DESK_FRAME_URL', 'DEFAULT_FRAGMENT_PREFIX', 'TenantService', 'application'];
    constructor($stateParams, $scope, $location, $sce, LoadingService, DESK_FRAME_URL, DEFAULT_FRAGMENT_PREFIX, TenantService, application) {
        'ngInject';
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.$location = $location;
        this.$sce = $sce;
        this.LoadingService = LoadingService;
        const params = this.$stateParams.path;
        let queryString = this.$location.url().split('?')[1];
        queryString = queryString ? `?${queryString}` : '';
        const deskFrameUrl = application.tenantId
            ? TenantService.addTenantPrefixToUrl(DESK_FRAME_URL, application.tenantId)
            : TenantService.addTenantPrefixToUrl(DESK_FRAME_URL, DEFAULT_FRAGMENT_PREFIX);
        this.frameUrl = this.$sce.trustAsResourceUrl(`${deskFrameUrl}${params}${queryString}`);
        this.LoadingService.startLoading();
    }
    $onInit() {
        this.errorMessage =
            'Error while loading Help Desk module. Refresh the page or try again later';
        this.$scope.$on('$destroy', this.LoadingService.stopLoading);
    }
    onFrontendLoad() {
        this.LoadingService.stopLoading();
    }
    onFrontendError() {
        this.LoadingService.stopLoading();
    }
}
DeskController.$inject = ['$stateParams', '$scope', '$location', '$sce', 'LoadingService', 'DESK_FRAME_URL', 'DEFAULT_FRAGMENT_PREFIX', 'TenantService', 'application'];
